// MapComponent.tsx
import React, { useEffect, useRef, useState } from 'react'
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet'
import L, { LatLngExpression, Map } from 'leaflet'
import 'leaflet/dist/leaflet.css'
import { CurrentSession } from '@/services/repository/session'
import { Services } from '@/services/services'
import { defaultMapCenter } from '@/env/config'

export interface MapPointRow {
  // imei: string
  // time: string // ISO 8601 string representation of DtServer (e.g., "2025-01-17T12:34:56Z")
  lat: number  // Latitude as a floating-point number
  lng: number  // Longitude as a floating-point number
  // altitude: number // Altitude in meters
  angle: number // Angle in degrees
  // speed: number // Speed in meters per second
}

export const MapPointComponent = ({ services, session, row }: {
  services: Services,
  session: CurrentSession,
  row: MapPointRow
}) => {
  const mapRef = useRef<Map>(null)
  const [myposition, setMyPosition] = useState<[number, number] | undefined>(undefined)

  useEffect(() => {
    if (mapRef.current) {
      mapRef.current.invalidateSize();
    }
  }, [mapRef]); // Trigger resize on open

  useEffect(() => {
    // Function to handle geolocation success
    const handleSuccess = (location: GeolocationPosition) => {
      const { latitude, longitude } = location.coords
      setMyPosition([latitude, longitude])
    }

    // Function to handle geolocation error
    const handleError = (error: GeolocationPositionError) => {
      console.error('Error obtaining location:', error)
      // Fallback to a default position if geolocation fails
      setMyPosition(undefined)
    }

    // Check if geolocation is available
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(handleSuccess, handleError)
    } else {
      console.error('Geolocation is not supported by this browser.')
      // Fallback to a default position if geolocation is not supported
      setMyPosition(undefined)
    }
  }, [])

  const center: LatLngExpression = (row && {
    lat: row.lat,
    lng: row.lng
  }) || defaultMapCenter

  return (
    <MapContainer attributionControl={false} ref={mapRef} center={center} zoom={13} style={{ height: '80vh', width: '100%' }}>
      <TileLayer
        attribution='&copy <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
      />
      <Marker
        key='main-point'
        position={row}
        icon={L.divIcon({
          className: 'car-icon',
          html: row.angle ? `<img src="/public/img/gps/vehicle_arrow.png" style="transform: rotate(${row.angle + 45}deg); width: 16px" />` : `<img src="/public/img/gps/map_point.png" style="transform: rotate(${row.angle + 45}deg); width: 16px" />`,
          iconSize: [16, 16], // Adjust size as needed
          iconAnchor: [8, 8], // Anchor point
        })} >
        {/* <Popup>
          <div>
            <p>{session.translates.for('map.speed')}: {row.speed} km/h</p>
            <p>{session.translates.for('map.direction')}: {row.angle}°</p>
          </div>
        </Popup> */}
      </Marker>

      {myposition ? <Marker
        key='my-location'
        position={myposition}
        icon={L.divIcon({
          className: 'car-icon',
          html: `<img src="/public/img/gps/i_am_here.png" style="width: 32px" />`,
          iconSize: [32, 32], // Adjust size as needed
          iconAnchor: [16, 16], // Anchor point
        })}></Marker> : null}
    </MapContainer>
  )
}
